import { GET_REGION, SET_REGION } from "./RegionType";

const getRegionByEmailId = (emailId: any) => ({
    emailId,
    type: GET_REGION,
});

const setRegionByEmailId = (regionDropDownList: any) => ({
    type: SET_REGION,
    regionDropDownList
});

export {
    getRegionByEmailId,
    setRegionByEmailId
}
